import { useSetAtom } from "jotai";
import {
  setConfirmationModalAtom,
  setEmployeesGroupModalAtom,
  setModalCloseAtom,
} from "atoms/modalAtom/modalAtom";
import { useEmployeesState } from "atoms/employeesAtom";

import { Button } from "components/Button/Button";
import { HorizontalSpace } from "components/HorizontalSpace/HorizontalSpace";

import { useDeleteEmployeesGroup } from "../api";

export const EmployeesGroupFooter = (): JSX.Element => {
  const { employeesState } = useEmployeesState();
  const setEmployeesGroupModal = useSetAtom(setEmployeesGroupModalAtom);
  const setConfirmationModal = useSetAtom(setConfirmationModalAtom);
  const setModalClose = useSetAtom(setModalCloseAtom);

  const { mutate: deleteEmployeesGroup } = useDeleteEmployeesGroup();

  const onConfirm = () => {
    deleteEmployeesGroup(employeesState.activeGroupItem!.item.usersgroupid);

    setModalClose();
  };

  const handleEditClick = () => {
    if (employeesState.activeGroupItem) {
      setEmployeesGroupModal(true);
    }
  };

  const handleDeleteClick = () => {
    if (employeesState.activeGroupItem) {
      setConfirmationModal({
        title: `Вы действительно хотите удалить должность "${employeesState.activeGroupItem!.item.name}"?`,
        onConfirm,
      });
    }
  };

  return (
    <div className="flex flex-row ">
      <Button icon="plus" onClick={() => setEmployeesGroupModal(false)} />
      <HorizontalSpace size={11} />
      <Button
        disabled={!employeesState.activeGroupItem}
        icon="delete"
        onClick={handleDeleteClick}
      />
      <HorizontalSpace size={11} />
      <Button
        disabled={!employeesState.activeGroupItem}
        icon="info"
        onClick={handleEditClick}
      />
    </div>
  );
};
